const Qs = require('qs')

const baseUrl = process.env.MIX_API_URL
const prefix = 'instagram/'
const prefixV2 = 'private/instagram/'

const performRequest = async (method, url, data, extra = {}) => {
    let request = {
        method: method,
        url: prefix + url,
        baseURL: baseUrl,
        paramsSerializer: function(params) {
            return Qs.stringify(params, {arrayFormat: 'repeat'})
        },
        headers: {
            'Authorization': Spark.jwtToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    }

    if (method === 'get' || method === 'delete') {
        request.params = data
    } else {
        request.data = data
    }

    if (Object.keys(data).length) {
        request = Object.assign({}, request,  extra)
    }

    const response = await axios(request)

    const results = await response.data
    return results
}

const performRequestV2 = async (method, url, data, extra = {}) => {
    let request = {
        method: method,
        url: prefixV2 + url,
        baseURL: baseUrl,
        paramsSerializer: function(params) {
            return Qs.stringify(params, {arrayFormat: 'repeat'})
        },
        headers: {
            'Authorization': Spark.jwtToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    }

    if (method === 'get' || method === 'delete') {
        request.params = data
    } else {
        request.data = data
    }

    if (Object.keys(data).length) {
        request = Object.assign({}, request,  extra)
    }

    const response = await axios(request)

    const results = await response.data
    return results
}

const InstagramService = {
    v2: {

        widgets: {
            index: async ({ } = {}) => {
                const results = await performRequestV2('get', 'widgets', {})
                return results
            },
            get: async({id}) => {
                const results = await performRequestV2('get', 'widgets/' + id, {})
                return results
            }
        },
        stats: {
            get: async ({ from, to, hashtags, type } = {}) => {
                let url = 'stats'

                if (type) url += '/' + type

                const results = await performRequestV2('get', url, {from, to, hashtags})
                return results
            },
        },
        posts: {
            index: async ({ from, to, sortOrder, sortBy, limit, page, hashtags } = {}) => {
                const results = await performRequestV2('get', 'posts', {from, to, sortOrder, sortBy, limit, page, hashtags})
                return results
            }
        },
        topics: {
            index: async ({ from, to, sortOrder, sortBy, hashtags } = {}) => {
                const results = await performRequestV2('get', 'topics', {from, to, sortOrder, sortBy, hashtags})
                return results
            }
        },
        hashtags: {
            index: async function({ from, to, sortOrder, sortBy, limit, hashtags } = {}) {
                const results = await performRequestV2('get', 'hashtags', {from, to, sortOrder, sortBy, limit, hashtags})
                return results
            }
        }
    },
    settings: {
        save: async({data}) => {
            let request = {
                method: 'put',
                url: '/api/instagram/' + Spark.state.currentTeam.id  + '/settings',
                data,
                withCredentials: true,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }

            const response = await axios(request)

            const results = await response.data
            return results
        },
        connect: async({data}) => {

            let request = {
                method: 'put',
                url: '/api/instagram/' + Spark.state.currentTeam.id  + '/connect-page',
                data,
                withCredentials: true,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }

            const response = await axios(request)

            const results = await response.data
            return results
        }
    },
    widgets: {
        create: async({data}) => {
            const results = await performRequestV2('post', 'widgets', data)
            return results
        },
        update: async({id, data}) => {
            const results = await performRequestV2('put', 'widgets/' + id, data)
            return results
        }
    },
    pages: {
        get: async () => {
            const results = await performRequest('get', 'facebook/page', {})
            return results
        }
    },
    comments: {
        index: async ({ from, to, limit, page, hashtags  } = {}) => {
            const results = await performRequest('get', 'comments', {from, to, limit, page, hashtags})
            return results
        },
        reply: async ({ id, message } = {}) => {
            const results = await performRequest('post', 'comments/reply', {id, message})
            return results
        }
    },
    suggestions: {
        index: async ({ from, to, hashtags, page }  = {}) => {
            const results = await performRequest('get', 'recommend', {from, to, hashtags, page})
            return results
        },
        create: async ({imageUrl, caption}) => {
            try{
                const results = await performRequest('post', 'recommend', {imageUrl, caption}, {responseType: 'arraybuffer'})
                const url = window.URL.createObjectURL(new Blob([results]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'instagram_recommendation_' + new Date().toDateString() + '.jpg');
                document.body.appendChild(link);
                link.click();
            } catch(error) {
                console.log(error)
                return new Promise(resolve => {
                    const reader = new FileReader();

                    reader.onload = async function() {
                        resolve(JSON.parse(reader.result));
                    }

                    reader.readAsText(error.response.data);
                })
            }
        }
    }
}

export default InstagramService

